<template>
  <div class="tabs-pane" :class="isActive" v-if="active">
      <slot></slot>
  </div>
</template>

<script>
export default {
    name: 'g-tabs-body-pane',
    inject:['eventBus'],
    props: {
        name:{
            type: String | Number,
            required: true
        }
    },
    data() {
        return {
            active:false
        }
    },
    created() {
        this.eventBus.$on('update:selected', (name) => {
            this.active = this.name === name
        })
    },
    computed: {
        isActive() {
            return {
                active: this.active
            }
        }
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.tabs-pane{

}
</style>